import { Column, Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui'
import { paths } from 'src/routes/paths'
import { useNavigate } from 'react-router-dom'

export const InvalidState = () => {
  const navigate = useNavigate()

  return (
    <Column className="w-full h-dvh items-center justify-center gap-4">
      <p>Invalid signup link</p>
      <Button onClick={() => navigate(paths.loginSignUp)}>
        Go to Signup
      </Button>
    </Column>
  )
}

